'use client';
import styled, { css } from 'styled-components';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { getColor } from '../../mixins/getColor.js';
import { getDisplayStyle } from '../../mixins/getDisplayStyle.js';
import { spaceProp } from '../../mixins/spaceProp.js';

const Box = styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => !['display'].includes(prop) && defaultValidatorFn(prop)
}).withConfig({
  componentId: "sc-1k3tq1j-0"
})(["", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", " ", ""], defaultStyles.boxSizing, ({
  borderRadius
}) => borderRadius && spaceProp(borderRadius, 'border-radius'), ({
  display
}) => display && getDisplayStyle(display), ({
  py
}) => py && css(["", " ", ""], spaceProp(py, 'padding-top'), spaceProp(py, 'padding-bottom')), ({
  px
}) => px && css(["", " ", ""], spaceProp(px, 'padding-left'), spaceProp(px, 'padding-right')), ({
  pt
}) => pt && css(["", ""], spaceProp(pt, 'padding-top')), ({
  pb
}) => pb && css(["", ""], spaceProp(pb, 'padding-bottom')), ({
  pl
}) => pl && css(["", ""], spaceProp(pl, 'padding-left')), ({
  pr
}) => pr && css(["", ""], spaceProp(pr, 'padding-right')), ({
  backgroundColor
}) => backgroundColor && css(["", ""], getColor(backgroundColor)), ({
  spaceAfter
}) => spaceProp(spaceAfter), ({
  spaceBefore
}) => spaceProp(spaceBefore, 'margin-top'));

export { Box };
//# sourceMappingURL=Box.js.map
